import './FwsRelated.css';

import React, { useEffect, useState } from 'react';
import { fullImagePath, generateClassName } from '../../b2b-common/helpers';
import usePlansFrameworks from '../hooks/usePlansFrameworks';
import { Add } from '@mui/icons-material';

export const FwRelated = ({ framework = null, className = null,
    showLogo = true, showLevel1s = true, level1sNumber = 4,
    iconsSize = 20 }) => {

    const [currentFramework, setCurrentFramework] = useState(framework);
    const [isClicked, setIsClicked] = useState(showLevel1s);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setCurrentFramework(framework);
    }, [framework]);

    const handleMouseEnter = () => {
        setShowAll(true);
    };

    const handleMouseLeave = () => {
        setShowAll(false);
    };

    return (
        currentFramework && (
            <div
                onClick={() => setIsClicked(!isClicked)}
                className={generateClassName('fw-related', '-fw-logo', className)}
            >
                {showLogo && (
                    <img
                        src={fullImagePath(currentFramework.frameworkDTO.imagePath)}
                        alt={currentFramework.frameworkDTO.frameworkName}
                        className={generateClassName('fw-related', '-fw-image', className)}
                        style={{ width: iconsSize, height: iconsSize }}
                    />
                )}
                {isClicked && (
                    <div className={generateClassName('fw-related', '-fw-levelns', className)}>
                        {currentFramework.level1sDTOs.slice(0, level1sNumber).map(level => {
                            const bulletImage = fullImagePath(level.otherImages.find(image => image.endsWith('_bullet.jpg')));
                            return (
                                <img key={level.levelN_ItemId} src={bulletImage} alt={level.levelN_ItemName}
                                    className={generateClassName('fw-related', '-fw-leveln-bullet', className)}
                                    style={{ width: iconsSize, height: iconsSize }}
                                />
                            );
                        })}
                        {currentFramework.level1sDTOs.length > level1sNumber && (
                            <>
                                <Add style={{ width: iconsSize, height: iconsSize, backgroundColor: 'white' }}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                />
                                <div
                                    className={generateClassName('fw-related', '-fw-more-icon', className)}
                                >
                                    {showAll && (
                                        <div className={generateClassName('fw-related', '-fw-all-levelns', className)}>
                                            {currentFramework.level1sDTOs.map(level => {
                                                const bulletImage = fullImagePath(level.otherImages.find(image => image.endsWith('_bullet.jpg')));
                                                return (
                                                    <img key={level.levelN_ItemId} src={bulletImage} alt={level.levelN_ItemName}
                                                        className={generateClassName('fw-related', '-fw-leveln-bullet', className)}
                                                        style={{ width: iconsSize, height: iconsSize }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        )
    );
};

const FwsRelated = ({ planUUID = null, className = null, showLevel1s = true }) => {

    const { genericFwsRelated, iotFwsRelated, verticalFwsRelated, softwareFwsRelated, partnerFwsRelated } =
        usePlansFrameworks(planUUID, [{ frameworkSuite: 'generic', fwIds: [1, 2] }]);

    const renderFwRelated = (fwRelated) => {
        const { frameworkDTO, level1sDTOs } = fwRelated;
        const framework = { frameworkDTO, level1sDTOs };
        return (
            <FwRelated key={frameworkDTO.frameworkId} framework={framework} className={className} showLevel1s={showLevel1s} />
        )
    }

    return (
        <div className={generateClassName('fws-related', '', className)}>
            <div className={generateClassName('fws-related', '-generic-fws-related', className)}>
                {genericFwsRelated && genericFwsRelated.length > 0 ?
                    genericFwsRelated.map((fwRelated) => renderFwRelated(fwRelated)) : null
                }
            </div>
            <div className={generateClassName('fws-related', '-iot-fws-related', className)}>
                {iotFwsRelated && iotFwsRelated.length > 0 ?
                    iotFwsRelated.map((fwRelated) => renderFwRelated(fwRelated)) : null
                }
            </div>
            <div className={generateClassName('fws-related', '-vertical-fws-related', className)}>
                {verticalFwsRelated && verticalFwsRelated.length > 0 ?
                    verticalFwsRelated.map((fwRelated) => renderFwRelated(fwRelated)) : null
                }
            </div>
            <div className={generateClassName('fws-related', '-software-fws-related', className)}>
                {softwareFwsRelated && softwareFwsRelated.length > 0 ?
                    softwareFwsRelated.map((fwRelated) => renderFwRelated(fwRelated)) : null
                }
            </div>
            <div className={generateClassName('fws-related', '-partner-fws-related', className)}>
                {partnerFwsRelated && partnerFwsRelated.length > 0 ?
                    partnerFwsRelated.map((fwRelated) => renderFwRelated(fwRelated)) : null
                }
            </div>
        </div>
    );
};

export default FwsRelated;